import { motion } from "framer-motion";
import { ArrowLeft, LogIn } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminLogin() {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#FBF7EE] text-[#211B10] flex flex-col">
      <div className="p-8">
        <Link to="/" data-testid="back-to-home-link" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-[#211B10]/50 hover:text-[#A67C1E] transition-colors">
          <ArrowLeft className="w-4 h-4" /> Kembali
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-md w-full border border-[#211B10]/10 bg-white p-12"
        >
          <img src="/nalura-logo.jpg" alt="Logo NALURA" className="w-16 h-16 object-contain mix-blend-multiply mb-5" />
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#A67C1E] mb-6">Area Admin — NALURA</p>
          <h1 className="font-display text-4xl tracking-tight mb-4">Masuk ke Dashboard</h1>
          <p className="text-sm text-[#211B10]/60 leading-relaxed mb-10">
            Kelola produk affiliate Anda, buat copy penjualan dengan AI, dan pantau performa klik — semua dari satu tempat.
          </p>
          <button
            data-testid="google-login-button"
            onClick={handleGoogleLogin}
            className="w-full inline-flex items-center justify-center gap-3 bg-[#A67C1E] text-[#FBF7EE] font-medium text-sm px-8 py-4 hover:bg-[#211B10] hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
          >
            <LogIn className="w-4 h-4" />
            Masuk dengan Google
          </button>
        </motion.div>
      </div>
    </div>
  );
}
